import cx from 'classnames';
import type { ReactNode } from 'react';
import { Typography } from '../Typography';
import styles from './styles.module.css';

export type Position = 'bottom' | 'top' | 'left' | 'right';

export interface TooltipProps {
  children: NonNullable<ReactNode>;
  content: NonNullable<ReactNode>;
  defaultVisible?: boolean;
  fullWidth?: boolean;
  position: Position;
}

export function Tooltip({ children, position = 'top', content, defaultVisible, fullWidth }: TooltipProps): ReactNode {
  return (
    <span className={styles.Container}>
      <Typography.div
        base="body"
        color="white-light"
        variant="regular"
        className={cx(styles.Tooltip, {
          [styles.Visible]: defaultVisible,
          [styles.Bottom]: position === 'bottom',
          [styles.Top]: position === 'top',
          [styles.Left]: position === 'left',
          [styles.Right]: position === 'right',
          [styles.FullWidth]: fullWidth,
        })}
      >
        <div className={styles.Content}>{content}</div>
      </Typography.div>
      {children}
    </span>
  );
}
